// @ts-nocheck
// Auto-add + cart-sync voor mixed offers. Op live stores laadt ook de app extension
// mixed-offer-cart-sync.js; __MIXED_OFFER_INIT__ voorkomt dubbele initialisatie.
(function initMixedOffer() {
  if (document.prerendering) {
    document.addEventListener('prerenderingchange', initMixedOffer, { once: true });
    return;
  }
  if (window.__MIXED_OFFER_INIT__) return; // voorkom dubbele init
  window.__MIXED_OFFER_INIT__ = true;
  
  var isApplying = false;
  var pendingRecompute = false;
  /** Hash van updates die succesvol op de cart zijn toegepast (niet alleen het compute-plan). */
  var lastAppliedUpdatesHash = "";
  var debounce = function (fn, ms) {
    var t;
    var debounced = function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, ms);
    };
    debounced.cancel = function () {
      clearTimeout(t);
    };
    return debounced;
  };

  // Injecteer CSS fallback om quantity-selector in gelockte cross-sell rijen te blokkeren
  (function injectMixedOfferStyle(){
    try {
      if (document.getElementById('mixed-offer-style')) return;
      var style = document.createElement('style');
      style.id = 'mixed-offer-style';
      style.textContent = '.cart-items__table-row[data-cross-sell-lock="true"] .quantity-selector{opacity:.4;pointer-events:none}';
      document.head.appendChild(style);
    } catch(e) {}
  })();

  // Gedeelde winkelmandstatus (SHO-10074): één /cart.js voor alle scripts die de mand
  // lezen. Dit is een classic script, dus geen import — cart-state.js zet dezelfde staat
  // op window en staat eerder in de HTML. Valt het weg, dan halen we hem zelf op.
  function getCart(opties) {
    var gedeeld = window.HdsCartState;
    if (gedeeld) return gedeeld.getCart(opties);
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function lineContextsForCart(cart) {
    var store = window.__MIXED_OFFER_LINE_CONTEXTS__;
    if (!store || !cart || !Array.isArray(cart.items)) return undefined;
    var contexts = [];
    cart.items.forEach(function (item) {
      if (isCrossSellItemLine(item)) return;
      var pid = String(item.product_id);
      var vid = item.variant_id ? String(item.variant_id) : '';
      var ctx = store[pid + ':' + vid] || store[pid + ':'];
      if (ctx) contexts.push(ctx);
    });
    return contexts.length ? contexts : undefined;
  }

  // A/B-armen van de bezoeker (MKT-1704): het thema bepaalt de arm, de engine bepaalt wat
  // die arm krijgt. Een actie-blok zet ze op window.__HDS_EXPERIMENT_ARMS__ als { id: arm };
  // ontbreekt dat, dan sturen we niets mee en verbergt de engine experiment-campagnes (fail closed).
  function experimentArms() {
    try {
      var arms = window.__HDS_EXPERIMENT_ARMS__;
      if (arms && typeof arms === 'object' && Object.keys(arms).length) return arms;
    } catch (e) {}
    return null;
  }

  // De armen zet hds-experiment-arms.js (module, eerder in de HTML). Laadt dit script toch
  // eerder, wacht dan kort: zonder arm verbergt de engine de experiment-campagnes, en dan
  // zou de gratis lijm even uit de mand verdwijnen.
  function whenArmsReady() {
    if (window.__HDS_EXPERIMENT_ARMS_READY__) return Promise.resolve();
    return new Promise(function (resolve) {
      var done = function () { clearTimeout(timer); resolve(); };
      var timer = setTimeout(done, 1500);
      document.addEventListener('hds:experiment-arms', done, { once: true });
    });
  }

  function compute(items, lineContexts) {
    return whenArmsReady().then(function () { return computeNow(items, lineContexts); });
  }

  function computeNow(items, lineContexts) {
    var url = '/apps/cross-sell/compute';
    var body = { items: items, source: 'theme' };
    if (lineContexts && lineContexts.length) {
      body.lineContexts = lineContexts;
    }
    var arms = experimentArms();
    if (arms) body.experiments = arms;
    return fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : { updates: [], messages: [] }; });
  }

  // Het plan van de engine is ook voor anderen interessant: de drempel-voortgang
  // (`thresholds[]`, MKT-1705) voedt de balk in de drawer en de slot-stand van het
  // cadeau-blok op de PDP. Eén bron: de laatste stand staat op window, de wijziging
  // komt als event. `inCart` wordt bijgesteld naar wat er ná de updates in de mand ligt,
  // want een verwijderde seed vuurt bewust geen nieuwe compute.
  function publishPlan(cart, plan) {
    try {
      var thresholds = Array.isArray(plan && plan.thresholds) ? plan.thresholds : [];
      var byVariant = {};
      (plan && plan.updates || []).forEach(function (u) {
        byVariant[String(u.variantId)] = Math.max(0, parseInt(u.desiredQuantity, 10) || 0);
      });
      thresholds = thresholds.map(function (t) {
        var desired = byVariant[String(t.variantId)];
        if (desired === undefined) return t;
        var copy = {};
        for (var k in t) copy[k] = t[k];
        copy.inCart = desired > 0;
        return copy;
      });
      var detail = { thresholds: thresholds, cart: cart || null, at: Date.now() };
      window.__MIXED_OFFER_LAST_PLAN__ = detail;
      document.dispatchEvent(new CustomEvent('mixed-offer:plan', { detail: detail }));
    } catch (e) {}
  }

  function itemsForCompute(cart) {
    return cart.items.map(function (i) {
      return {
        productId: i.product_id,
        variantId: i.variant_id,
        quantity: i.quantity,
        properties: i.properties || null
      };
    });
  }

  function variantToLines(cart) {
    var map = Object.create(null);
    cart.items.forEach(function (i) {
      var arr = map[i.variant_id] || [];
      arr.push({ key: i.key, qty: i.quantity, properties: i.properties || {} });
      map[i.variant_id] = arr;
    });
    return map;
  }

  function lineHasCrossSellProps(line, properties) {
    if (!properties) return true;
    var lp = (line && line.properties) || {};
    if (
      String(properties._cross_sell || '').toLowerCase() === 'true' &&
      String(lp._cross_sell || '').toLowerCase() !== 'true'
    ) {
      return false;
    }
    if (
      String(properties._is_free || '').toLowerCase() === 'true' &&
      String(lp._is_free || '').toLowerCase() !== 'true'
    ) {
      return false;
    }
    // Lijmkeuze: de regel moet via dezelfde weg gratis zijn als het plan zegt (€ 0 of code).
    // Anders herschrijven, bijvoorbeeld bij de start van de test met lijm al in de mand.
    if (
      String(properties._is_free || '').toLowerCase() === 'true' &&
      String(properties._free_via || '') !== String(lp._free_via || '')
    ) {
      return false;
    }
    return true;
  }

  function planToLineUpdates(cart, plan) {
    var v2l = variantToLines(cart);
    var updates = [];

    (plan.updates || []).forEach(function (u) {
      var variantId = String(u.variantId);
      var desired = Math.max(0, parseInt(u.desiredQuantity, 10) || 0);
      var lines = v2l[variantId] || v2l[Number(variantId)] || [];
      var current = lines.reduce(function (s, l) { return s + l.qty; }, 0);
      var props = u.properties || null;
      var needsCrossSellProps =
        !!props &&
        (String(props._cross_sell || '').toLowerCase() === 'true' ||
          String(props._is_free || '').toLowerCase() === 'true');
      var propsMissing =
        needsCrossSellProps &&
        lines.some(function (line) {
          return !lineHasCrossSellProps(line, props);
        });

      // Opt-in gratis: qty klopt al, maar regel mist _is_free/_cross_sell → herschrijven
      if (current === desired && !propsMissing) return;

      if (desired > 0 && propsMissing) {
        lines.forEach(function (line) {
          updates.push({ type: 'line', key: line.key, qty: 0, prevQty: line.qty });
        });
        if (lines.length > 0 || u.allowAutoAdd) {
          updates.push({
            type: 'add',
            variantId: variantId,
            qty: desired,
            crossSellItemId: u.crossSellItemId,
            properties: props
          });
        }
        return;
      }

      var remaining = desired;
      // Stel bestaande lines in eerste instantie omlaag/omhoog naar remaining, rest wordt add
      for (var idx = 0; idx < lines.length; idx++) {
        var line = lines[idx];
        var newQty = Math.min(line.qty, remaining);
        updates.push({ type: 'line', key: line.key, qty: newQty, prevQty: line.qty });
        remaining -= newQty;
      }

      // Toevoegen als de variant al in de cart zit (qty-sync) OF als het een auto-add cadeau is
      // (mag uit het niets toegevoegd worden). Optionele cross-sells worden niet auto-geadd.
      if (remaining > 0 && (lines.length > 0 || u.allowAutoAdd)) {
        updates.push({ type: 'add', variantId: variantId, qty: remaining, crossSellItemId: u.crossSellItemId, properties: props });
      }

      if (desired === 0 && lines.length) {
        lines.forEach(function (line) { updates.push({ type: 'line', key: line.key, qty: 0 }); });
      }
    });

    return updates;
  }

  function applyCartMutation(response) {
    if (!response || !response.ok) {
      return response.text().then(function (body) {
        var err = new Error('Cart mutation failed (' + (response ? response.status : 'no response') + ')');
        err.responseBody = body;
        throw err;
      });
    }
    return response.json().catch(function () { return null; });
  }

  function applyUpdates(updates) {
    var lineEntries = updates.filter(function (u) { return u.type === 'line'; });
    var addEntries = updates.filter(function (u) { return u.type === 'add'; });

    var p = Promise.resolve();

    if (lineEntries.length) {
      var fd = new FormData();
      lineEntries.forEach(function (u) { fd.append('updates[' + u.key + ']', String(u.qty)); });
      p = p.then(function () {
        return fetch('/cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin' }).then(applyCartMutation);
      });
    }

    addEntries.forEach(function (u) {
      p = p.then(function () {
        var baseProps = {
          _cross_sell: 'true'
        };
        if (u.properties) {
          for (var k in u.properties) {
            if (Object.prototype.hasOwnProperty.call(u.properties, k)) {
              baseProps[k] = String(u.properties[k]);
            }
          }
        }
        var body = {
          id: Number(u.variantId),
          quantity: u.qty,
          properties: baseProps
        };
        
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        }).then(applyCartMutation);
      });
    });

    // Alleen na add of decrease (niet bij pure increase of no-op)
    var hadAdd = addEntries.length > 0;
    var hadDecrease = lineEntries.some(function (u) { return (u.prevQty || 0) > u.qty; });
    if (hadAdd || hadDecrease) {
      p = p.then(function(){ return getCart({ vers: true }); })
        .then(function(cart){
          try {
            var evt = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'mixed-offer', data: { itemCount: cart.item_count } } });
            document.dispatchEvent(evt);
            window.dispatchEvent(evt);
            disableCrossSellQuantity(cart);
          } catch(e) {}
        });
    }

    return p;
  }

  // Een regel telt als "trigger-kandidaat" als het GEEN cross-sell regel is (bijv. verf).
  // Nodig zodat auto-add cadeaus ook berekend worden wanneer er nog geen cross-sell in de mand zit.
  function isCrossSellItemLine(item) {
    if (!item || !item.properties) return false;
    var p = item.properties;
    if (String(p._cross_sell || '').toLowerCase() === 'true') return true;
    return ['_is_free', '_max_quantity', '_discount_type', '_quantity_rule_type', '_quantity_rule_config'].some(function (k) {
      return p[k] !== undefined && p[k] !== null && String(p[k]).trim() !== '';
    });
  }

  // ── Lijmkeuze (DB-026, SHO-10800) ────────────────────────────────────────────────
  // In de testarm is de lijm niet € 0 maar gratis via de code GRATISLIJM (regel met
  // `_free_via=code`). Die code vullen we zelf in, naast codes die ermee samengaan (verzendcode);
  // vult de klant een eigen product- of ordercode in, dan vervangt die GRATISLIJM
  // (cart-discount.js) en betaalt hij de lijm. Zo kiest de klant.
  var FREE_VIA_CODE = 'GRATISLIJM';
  var lastFreeViaAttempt = '';
  // Codes waarvan we zagen dat ze wegvallen naast GRATISLIJM (eigen 10%-code e.d.): daar niet
  // opnieuw GRATISLIJM bij proberen, want Shopify kiest dan GRATISLIJM en de klant verliest zijn keuze.
  // Ook cart-discount.js schrijft hierin (sessionStorage `hds_freevia_conflicts`).
  var CONFLICTS_KEY = 'hds_freevia_conflicts';
  function readConflicts() {
    try { return JSON.parse(sessionStorage.getItem(CONFLICTS_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function rememberConflicts(list) {
    var all = readConflicts();
    list.forEach(function (code) { all[String(code).toUpperCase()] = true; });
    try { sessionStorage.setItem(CONFLICTS_KEY, JSON.stringify(all)); } catch (e) {}
  }

  function hasCodeFreeLine(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.some(function (i) {
      return i && i.quantity > 0 && i.properties && String(i.properties._free_via || '') === 'code';
    }));
  }

  function isFreeViaCode(code) {
    return String(code || '').toUpperCase() === FREE_VIA_CODE;
  }

  function syncFreeViaCode(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return Promise.resolve();
    var codes = cart.discount_codes;
    var applicable = codes.filter(function (d) { return d && d.applicable !== false; });
    var ours = codes.some(function (d) { return d && isFreeViaCode(d.code); });
    var hasLine = hasCodeFreeLine(cart);
    var next = null;
    var keep = applicable.map(function (d) { return d.code; });
    var conflicts = readConflicts();
    var blocked = keep.some(function (code) { return conflicts[String(code).toUpperCase()]; });

    if (hasLine && !ours && !blocked) {
      // Gratis lijm aan, naast de codes die er al geldig op staan. Een ongeldige code valt weg.
      next = keep.concat([FREE_VIA_CODE]).join(',');
    } else if (!hasLine && ours) {
      // Lijm weg of in de controle-arm: GRATISLIJM hoort er niet meer op.
      next = codes
        .filter(function (d) { return d && !isFreeViaCode(d.code); })
        .map(function (d) { return d.code; })
        .join(',');
    }
    if (next === null) {
      // Mand is in orde (bijv. eigen code actief): een latere toestand mag opnieuw proberen,
      // ook als die gelijk is aan een eerdere (code weer weggehaald → GRATISLIJM terug).
      lastFreeViaAttempt = '';
      return Promise.resolve();
    }

    // Eén poging per toestand, zodat een geweigerde code geen lus wordt.
    var attempt = next + '|' + codes.map(function (d) { return d.code + ':' + d.applicable; }).join(',') + '|' + cart.item_count;
    if (attempt === lastFreeViaAttempt) return Promise.resolve();
    lastFreeViaAttempt = attempt;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: next })
    })
      .then(applyCartMutation)
      .then(function () { return getCart({ vers: true }); })
      .then(function (fresh) {
        // Viel een eigen code weg naast GRATISLIJM? Dan botst hij: eigen code terug, GRATISLIJM eruit.
        var dropped = keep.filter(function (code) {
          return (fresh.discount_codes || []).some(function (d) {
            return d && d.code === code && d.applicable === false;
          });
        });
        if (dropped.length && keep.length) {
          rememberConflicts(dropped);
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: keep.join(',') })
          }).then(function () { return getCart({ vers: true }); });
        }
        return fresh;
      })
      .then(function (fresh) {
        try {
          var evt = new CustomEvent('cart:update', { bubbles: true, detail: { resource: fresh, sourceId: 'mixed-offer', data: { itemCount: fresh.item_count } } });
          document.dispatchEvent(evt);
          window.dispatchEvent(evt);
        } catch (e) {}
      })
      .catch(function (err) {
        try { console.warn('[mixed-offer] GRATISLIJM bijwerken mislukt', err); } catch (e) {}
      });
  }

  // De bezoeker telt mee zodra een cadeau van een experiment-campagne in de mand ligt:
  // daar lopen de armen uiteen (€ 0 tegenover gewone prijs + code).
  function exposePlan(plan) {
    try {
      var api = window.HDSExperiments;
      if (!api || typeof api.expose !== 'function') return;
      (plan && plan.updates || []).forEach(function (u) {
        if (u && u.experimentId && (parseInt(u.desiredQuantity, 10) || 0) > 0) {
          api.expose(String(u.experimentId), { source: 'cart' });
        }
      });
    } catch (e) {}
  }

  function afterPlan(cart, plan, cartChanged) {
    exposePlan(plan);
    var current = cartChanged ? getCart({ vers: true }) : Promise.resolve(cart);
    return current.then(syncFreeViaCode).catch(function () {});
  }

  // Altijd /cart.js als bron van waarheid (geen partial cart:update payloads).
  // Lock vóór async compute zodat parallelle cart:update events niet dubbel auto-adden (SHO-9134).
  var runRecompute = function () {
    if (isApplying) {
      pendingRecompute = true;
      return;
    }
    isApplying = true;
    getCart()
      .then(function (cart) {
        var needsEnforcement = Array.isArray(cart && cart.items) && cart.items.some(shouldLockItem);
        // Ook berekenen zodra er een trigger-kandidaat (niet-cross-sell product) in de mand ligt,
        // zodat auto-add cadeaus uit het niets kunnen worden toegevoegd.
        var hasTriggerCandidate = Array.isArray(cart && cart.items) && cart.items.some(function (i) { return !isCrossSellItemLine(i); });
        var shouldCompute = needsEnforcement || hasTriggerCandidate;
        if (!needsEnforcement) {
          disableCrossSellQuantity(cart);
        }
        return Promise.all([
          Promise.resolve(cart),
          shouldCompute ? compute(itemsForCompute(cart), lineContextsForCart(cart)) : Promise.resolve({ updates: [] })
        ]);
      })
      .then(function (tuple) {
        var cart = tuple[0];
        var plan = tuple[1] || { updates: [] };
        var updates = planToLineUpdates(cart, plan);
        if (!updates.length) {
          lastAppliedUpdatesHash = "";
          disableCrossSellQuantity(cart);
          publishPlan(cart, plan);
          return afterPlan(cart, plan, false);
        }
        var updatesHash = JSON.stringify(updates);
        if (updatesHash === lastAppliedUpdatesHash) {
          disableCrossSellQuantity(cart);
          publishPlan(cart, plan);
          return afterPlan(cart, plan, false);
        }
        return applyUpdates(updates)
          .then(function () {
            lastAppliedUpdatesHash = updatesHash;
            publishPlan(cart, plan);
            return afterPlan(cart, plan, true);
          })
          .catch(function (err) {
            lastAppliedUpdatesHash = "";
            try { console.warn('[mixed-offer] Kon cart-updates niet toepassen', err); } catch (e) {}
            publishPlan(cart, { updates: [], thresholds: plan.thresholds });
          });
      })
      .catch(function (err) {
        try { console.warn('[mixed-offer] Recompute mislukt', err); } catch (e) {}
        publishPlan(null, { updates: [], thresholds: [] });
      })
      .finally(function () {
        isApplying = false;
        if (pendingRecompute) {
          pendingRecompute = false;
          runRecompute();
        }
      });
  };

  var recomputeDebounced = debounce(function () {
    runRecompute();
  }, 120);

  function scheduleRecompute() {
    recomputeDebounced();
  }

  var LOCK_ATTR = 'data-cross-sell-lock';
  var CONTROL_ATTR = 'data-cross-sell-lock-applied';

  function shouldLockItem(item){
    if (!item || !item.properties) return false;
    var props = item.properties;
    var explicitCrossSellFlag = String(props._cross_sell || '').toLowerCase() === 'true';
    var hasCrossSellIndicators = ['_cross_sell', '_is_free', '_max_quantity', '_discount_type', '_quantity_rule_type', '_quantity_rule_config'].some(function(key){
      return props[key] !== undefined && props[key] !== null && String(props[key]).trim() !== '';
    });
    var isCrossSell = explicitCrossSellFlag || hasCrossSellIndicators;
    if (!isCrossSell) return false;
    var isZeroPriced = Number(item.final_line_price || item.final_price || item.price) === 0;
    var isFree = isZeroPriced || String(props._is_free || '').toLowerCase() === 'true';
    var hasMax = props._max_quantity !== undefined && props._max_quantity !== null && String(props._max_quantity).trim() !== '';
    var ruleType = String(props._quantity_rule_type || '').trim();
    var hasRule = ruleType !== '';
    return isFree || hasMax || hasRule;
  }

  function toggleControlDisabled(control, shouldDisable){
    if (!control) return;
    if (shouldDisable) {
      if (!control.getAttribute(CONTROL_ATTR)) {
        control.setAttribute(CONTROL_ATTR, 'true');
      }
      control.disabled = true;
      control.setAttribute('disabled','');
    } else if (control.getAttribute(CONTROL_ATTR) === 'true') {
      control.disabled = false;
      control.removeAttribute(CONTROL_ATTR);
      control.removeAttribute('disabled');
    }
  }

  function applyLockState(row, shouldLock){
    if (!row) return;
    try { row.setAttribute(LOCK_ATTR, shouldLock ? 'true' : 'false'); } catch(e) {}
    try {
      if (shouldLock) {
        row.setAttribute('data-cross-sell', 'true');
      } else {
        row.removeAttribute('data-cross-sell');
      }
    } catch(e) {}
    var qs = row.querySelector('.quantity-selector');
    var input = row.querySelector('input[name="updates[]"]');
    var minus = row.querySelector('.quantity-minus');
    var plus = row.querySelector('.quantity-plus');

    toggleControlDisabled(input, shouldLock);
    toggleControlDisabled(minus, shouldLock);
    toggleControlDisabled(plus, shouldLock);

    if (qs) {
      if (shouldLock) {
        qs.setAttribute(CONTROL_ATTR, 'true');
        qs.setAttribute('aria-disabled','true');
        qs.setAttribute('disabled','');
        qs.style.pointerEvents = 'none';
        qs.style.opacity = '.4';
      } else if (qs.getAttribute(CONTROL_ATTR) === 'true') {
        qs.removeAttribute(CONTROL_ATTR);
        qs.removeAttribute('disabled');
        qs.setAttribute('aria-disabled','false');
        qs.style.pointerEvents = '';
        qs.style.opacity = '';
      }
    }
  }

  function disableCrossSellQuantity(cart){
    try { window.__MIXED_OFFER_LAST_CART__ = cart; } catch(e) {}
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return;
    }

    (cart.items || []).forEach(function(item){
      var selector = '[data-key="' + item.key + '"]';
      var row = document.querySelector(selector);
      if (!row) return;

      var lock = shouldLockItem(item);
      applyLockState(row, lock);

      if (lock) {
        setTimeout(function(){
          var verifyRow = document.querySelector(selector);
          if (!verifyRow) return;
          applyLockState(verifyRow, true);
        }, 100);
      }
    });
  }

  // Hard block interacties op cross-sell quantity (fallback tegen re-render enabling)
  function isLockedCrossSellRow(el){
    try {
      var row = el && el.closest && el.closest('tr[data-key]');
      if(!row) return false;
      return row.getAttribute(LOCK_ATTR) === 'true';
    } catch(e) { return false; }
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t) return;
    if (t.closest && (t.closest('.quantity-minus') || t.closest('.quantity-plus'))) {
      if (isLockedCrossSellRow(t)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }
  }, true);

  document.addEventListener('input', function(e){
    var t = e.target;
    if(!t || t.name !== 'updates[]') return;
    if (isLockedCrossSellRow(t)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      try { t.value = t.getAttribute('value') || String(t.value); } catch(err) {}
    }
  }, true);

  // Observe cart containers om na (re)render opnieuw te locken
  try {
    var cartObserver = new MutationObserver(function(){
      var cart = window.__MIXED_OFFER_LAST_CART__;
      if (cart && cart.items && cart.items.length) {
        disableCrossSellQuantity(cart);
      }
    });
    var attachObserver = function(){
      var containers = document.querySelectorAll('.cart-items__wrapper, .cart-drawer__content, main[role="main"]');
      containers.forEach(function(c){
        try { cartObserver.observe(c, { subtree: true, childList: true }); } catch(e) {}
      });
    };
    attachObserver();
    document.addEventListener('shopify:section:load', attachObserver);
  } catch(e) {}

  // Alleen luisteren op cart:update (thema-event)
  var onCartUpdate = function (e) {
    var sourceId = e && e.detail && e.detail.sourceId;
    var payloadCart = e && e.detail && e.detail.resource;
    var doLocks = function(cart){
      try {
        disableCrossSellQuantity(cart);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 100);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 300);
      } catch(err) {}
    };
    try{
      if (payloadCart && Array.isArray(payloadCart.items) && payloadCart.items.length > 0) {
        doLocks(payloadCart);
      } else {
        // Fallback: haal actuele cart op als payload leeg is (bijv. header event)
        getCart().then(function(cart){ doLocks(cart); });
      }
    }catch(err){}
    if (sourceId === 'mixed-offer') {
      return;
    }
    scheduleRecompute();
  };
  document.addEventListener('cart:update', onCartUpdate);
  window.addEventListener('cart:update', onCartUpdate);
  // Code toegevoegd of weggehaald in cart-discount.js: alleen de GRATISLIJM-keuze bijwerken
  // (geen herberekening nodig, de regels veranderen niet).
  document.addEventListener('discount:update', function () {
    getCart({ vers: true }).then(syncFreeViaCode).catch(function () {});
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      getCart().then(function(cart){
        disableCrossSellQuantity(cart);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 100);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 300);
      });
      scheduleRecompute();
    });
  } else {
    getCart().then(function(cart){
      disableCrossSellQuantity(cart);
      setTimeout(function(){ disableCrossSellQuantity(cart); }, 100);
      setTimeout(function(){ disableCrossSellQuantity(cart); }, 300);
    });
    scheduleRecompute();
  }

  // Geen extra hooks; enkel theme-event en eerste run

  // Expose voor snelle diagnose in console
  try { window.__MIXED_OFFER_RECOMPUTE__ = scheduleRecompute; } catch(e) {}
})();

